import * as types from './constants';
const PREFIX = "ui";

export default [
    // {
    //     path: [PREFIX, "localData"],
    //     actions: [types.SET_LOCAL_DATA],
    // }
]



// WEBPACK FOOTER //
// ./src/storeState/ui/localPersistence.js